import styled from "styled-components";

export const Header = styled.header`
  background-color: ${({ theme: { colors } }) => colors.white};
  padding: 15px 0;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  height: 100vh;
  width: 100vw;

  overflow-y: auto;

  z-index: 9999;

  transform: ${({ active }) =>
    active ? "translateX(0)" : "translateX(-100%)"};
  opacity: ${({ active }) => (active ? 1 : 0)};
  visibility: ${({ active }) => (active ? "visible" : "hidden")};

  transition: transform ${({ theme: { transition } }) => transition.slow},
    opacity ${({ theme: { transition } }) => transition.slow},
    visibility 0s linear ${({ active }) => (active ? "0s" : "0.4s")};
`;

export const Container = styled.div`
  position: relative;
  padding-top: 96px;
`;

export const Wtapper = styled.div`
  text-align: center;

  .logo {
    margin: auto;

    transform: scale(1.6);
  }
`;

export const MenuContainer = styled.nav`
  text-align: center;

  margin: 64px 0;
`;

export const MenuListWrapper = styled.ul`
  list-style-type: none;
  margin-bottom: 0;
  padding-left: 0;
`;

export const MenuItem = styled.li`
  display: block;
  padding: 4px 15px;

  opacity: ${({ open }) => (open ? 1 : 0)};
  transform: ${({ open }) => (open ? "translateY(0)" : "translateY(12px)")};
  transition: opacity 0.4s ease ${({ index }) => 0.08 + index * 0.06}s,
    transform 0.4s ease ${({ index }) => 0.08 + index * 0.06}s;

  a {
    display: inline-block;
    padding: 10px 18px;
    font-family: ${({ theme: { font } }) => font.heading};
    font-size: ${({ theme: { font } }) => font.big};
    font-weight: ${({ active }) => (active ? 700 : 500)};
    letter-spacing: -0.01em;
    color: ${({ active, theme: { colors } }) =>
      active ? colors.main.red : colors.slate[900]};
  }

  &.button a {
    background-color: ${({ theme: { colors } }) => colors.main.yellow};
    color: ${({ theme: { colors } }) => colors.navy[800]};
    padding: 12px 32px;
    margin-top: 20px;
    border-radius: ${({ theme: { radii } }) => radii.sm};
    font-size: ${({ theme: { font } }) => font.title};
    font-weight: 600;
    box-shadow: ${({ theme: { shadow } }) => shadow.sm};
  }
`;

export const MobileMenuContainer = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
`;

export const CloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 44px;
  height: 44px;

  background-color: ${({ theme: { colors } }) => colors.slate[100]};
  border: none;
  border-radius: ${({ theme: { radii } }) => radii.sm};
  color: ${({ theme: { colors } }) => colors.navy[800]};

  transition: background-color ${({ theme: { transition } }) => transition.fast};

  &:hover {
    background-color: ${({ theme: { colors } }) => colors.slate[200]};
  }

  svg {
    width: 24px;
    height: 24px;
  }
`;
